import { useMsal } from "@azure/msal-react";
import axios from "axios";
import React, { useEffect, useState } from "react";
import Floaticons from "../Floaticons";
import LearningCards from "./LearningCards";
import LearningJourney from "./LearningJourney";
import "./SREContent.css";
import mailData from ".././../data/mailData";
// import TestimonialsSection from "./TestimonialsSection";
function SREContent() {
  const { instance } = useMsal();
  const [username, setuserName] = useState(null);
  const [isUserPresent, setuserPresent] = useState(true);

  //const baseURL = "http://localhost:3004";
  const baseURL = "https://atci.lkm.accenture.com/shell-university-apis";
  let program = "SRE";
  const activeAccount = instance.getActiveAccount();
  // const checkUserPresent = (name) => {
  //   axios
  //     .get(`${baseURL}/checkNominationList/${name}/${program}`, {
  //       headers: {
  //         "Cache-Control": "no-cache",
  //         Accept: "application/json",
  //         Pragma: "no-cache",
  //         Expires: "0",
  //       },
  //     })
  //     .then((res) => {
  //       console.log("Reponse is", res.data);
  //       let users = res.data;
  //       axios
  //         .get(`${baseURL}/checkAdminList/${name}`, {
  //           headers: {
  //             "Cache-Control": "no-cache",
  //             Accept: "application/json",
  //             Pragma: "no-cache",
  //             Expires: "0",
  //           },
  //         })
  //         .then((res) => {
  //           console.log("Reponse is", res.data);

  //           users.length != 0 || res.data.length != 0
  //             ? setuserPresent(true)
  //             : setuserPresent(false);
  //         })
  //         .catch((err) => {
  //           console.log(err);
  //         });
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };
  const checkUserPresent = (name) => {
    axios
      .get(`${baseURL}/checkUserActive/${name}`, {
        headers: {
          "Cache-Control": "no-cache",
          Accept: "application/json",
          Pragma: "no-cache",
          Expires: "0",
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        let activeUser = res.data;
        if (activeUser.length != 0) {
          axios
            .get(`${baseURL}/checkNominationList/${name}/${program}`, {
              headers: {
                "Cache-Control": "no-cache",
                Accept: "application/json",
                Pragma: "no-cache",
                Expires: "0",
                Authorization: localStorage.getItem("token"),
                "Content-Type": "application/json",
              },
            })
            .then((res) => {
              let users = res.data;
              users.length != 0 ? setuserPresent(true) : setuserPresent(false);
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          axios
            .get(`${baseURL}/checkAdminList/${name}`, {
              headers: {
                "Cache-Control": "no-cache",
                Accept: "application/json",
                Pragma: "no-cache",
                Expires: "0",
                Authorization: localStorage.getItem("token"),
                "Content-Type": "application/json",
              },
            })
            .then((res) => {
              console.log("Reponse is", res.data);

              res.data.length != 0
                ? setuserPresent(true)
                : setuserPresent(false);
            })
            .catch((err) => {
              console.log(err);
            });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (activeAccount) {
      setuserName(activeAccount.idTokenClaims.enterpriseID);

      checkUserPresent(activeAccount.idTokenClaims.enterpriseID);
    } else {
      setuserName(null);
    }
  }, [activeAccount.idTokenClaims.enterpriseID]);

  return (
    <>
      <div id="SREContent">
        <div className="main-banner">
          <img
            src="images/SRE/SRE-banner-new.png"
            alt="Banner"
            className="banner-img"
          />
          <img
            src="images/Home/banner-strip.png"
            alt="strip"
            className="strip-img"
          />
          <div className="announcemnt-box">
            <p>
              <img
                src="images/Home/speaker.png"
                alt="speaker"
                className="speaker-img"
              />
              <marquee
                width="92%"
                direction="left"
                style={{ display: "inline-block", verticalAlign: "middle" }}
              >
                {" "}
                <b>Come Join Us</b> on an exhilarating learning Journey on
                Enbridge Talent Academy Platform!!!
              </marquee>
            </p>
          </div>
          <Floaticons />
        </div>
        {isUserPresent ? (
          <div className="main-container">
            {/* section 1  */}
            <div className="about-container">
              <div className="about-wrap">
                <h2>About SRE</h2>
                <p>
                  Site Reliability Engineering (SRE), focuses on delivering{" "}
                  <span> ultra-scalable</span> and{" "}
                  <span>highly reliable software systems.</span> SRE team uses
                  an engineering-based approach to manage systems, solve
                  problems, and automate operations tasks.
                </p>
              </div>
            </div>
            {/* section 2  */}
            <div id="SRE-Objective">
              <div className="program-container">
                <div className="program-wrap">
                  <h2>Program Objectives</h2>
                  <ul>
                    <li>
                      This program is intended for resources to enable them with
                      the required knowledge on Cloud, Agile, ITIL, Programming,
                      Automation, DevOps and its tools for implementation of SRE
                      and enhance customer experiences.{" "}
                    </li>
                    <li>
                      To build a skilled SRE workforce and ensure reliable &
                      resilience solution delivering for clients.
                    </li>
                  </ul>
                </div>
                <div className="program-robot">
                  <img
                    src="images/SRE/SRE-robot.png"
                    alt="SRE-machine"
                    className="SRE-robot"
                  />
                </div>
              </div>
            </div>
            <LearningJourney />
            <div className="casestudyNote">
              <p>
                <strong>Note: </strong>
                For Case Study details, please contact{" "}
                <a href={`mailto:${mailData.enbridge_talentAcademy_mail}`}>
                  {mailData.enbridge_talentAcademy_mail}
                </a>
              </p>{" "}
            </div>
            <div className="external-certification-container">
              <h5>External Certifications</h5>
              <p>
                Complete your learning journey and earn accredited external
                certification in the area of your expertise which can help in
                advancing your career.
              </p>
              <div className="ex-wrapper">
                <div className="ex-box">
                  <img
                    src="images/SRE/certificates/SRE-DevOps.png"
                    alt="certification-icon"
                  />
                  <span>SRE Foundation from DevOps Institute</span>
                </div>
                <div className="ex-box">
                  <img
                    src="images/SRE/certificates/SRE-Azure.png"
                    alt="certification-icon"
                  />
                  <span>AZ-900 Microsoft Azure Fundamentals</span>
                </div>
              </div>
            </div>
            <LearningCards />
            <div class="CardCheckYourLearningJourneyLinkContainerSREContainer">
              <button className="CardCheckYourLearningJourneyLinkContainerSRE">
                <a
                  className="CardCheckYourLearningJourneyLinkContainerLinkSRE"
                  target="_blank"
                  href="https://apps.powerapps.com/play/e/default-e0793d39-0939-496d-b129-198edd916feb/a/851e477e-5100-4b63-ac88-81eeb3d2ed9f?tenantId=e0793d39-0939-496d-b129-198edd916feb"
                >
                  Check your Learning Progress
                </a>
              </button>
            </div>
            <div className="features-container SRE">
              <h5>Program Highlights</h5>
              <div className="features-wrap">
                <div className="features-row">
                  <img
                    src="images/SRE/feature-icon1.png"
                    alt="feature-icon"
                    className="feature-icon"
                  />
                  <p>Self-paced Learning</p>
                </div>
                <div className="features-row">
                  <img
                    src="images/SRE/feature-icon2.png"
                    alt="feature-icon"
                    className="feature-icon"
                  />
                  <p>SME Connects</p>
                </div>
                <div className="features-row">
                  <img
                    src="images/SRE/feature-icon3.png"
                    alt="feature-icon"
                    className="feature-icon"
                  />
                  <p>Final Assessment</p>
                </div>
                <div className="features-row">
                  <img
                    src="images/SRE/feature-icon4.png"
                    alt="feature-icon"
                    className="feature-icon"
                  />
                  <p>Earn Completion Certificates, Flair, R&R</p>
                </div>
                <div className="features-row">
                  <img
                    src="images/SRE/feature-icon6.png"
                    alt="feature-icon"
                    className="feature-icon"
                  />
                  <p>End-to-End case studies</p>
                </div>
              </div>
            </div>
            <div>
              {/* <div className="testimonials_header_section">
                <img
                  src="images/Home/testimonial_header.png"
                  alt="header"
                  className="test_header_img"
                />
                <h5 className="testimonials_header">Testimonials</h5>
              </div> */}
              {/* <TestimonialsSection /> */}
            </div>
          </div>
        ) : (
          <div className="alter-conatiner">
            <p>
              You are not enrolled to this learning program. Please contact
              &nbsp;
              <a
                onClick={() => {
                  window.open(`mailto:${mailData.enbridge_talentAcademy_mail}`);
                }}
                href=""
              >
                {mailData.enbridge_talentAcademy_mail}
              </a>
              &nbsp; for any queries regarding the program.
            </p>
          </div>
        )}
      </div>
    </>
  );
}

export default SREContent;
